module.exports = __webpack_public_path__ + "img/ani_walking_man.0526c50.gif";